
    export enum EnumWorkflowStatus {
			Open = 0,
			Reopened = 1,
			AutoProcessed = 2,
			InProgress = 3,
			Closed = 4,
			RcReviewed = 5,
    }